import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

/**
 * `/ws/spa/presence` から受信した online ユーザー ID を管理する slice。
 * - snapshot で全件を置き換え、差分 event で add/remove する。
 * - 画面側は `useIsUserOnline(userId)` で利用する想定。
 */

export type PresenceState = {
  onlineUserIds: number[];
  isConnected: boolean;
};

const initialState: PresenceState = {
  onlineUserIds: [],
  isConnected: false,
};

const presenceSlice = createSlice({
  name: "presence",
  initialState,
  reducers: {
    setPresenceSnapshot: (state, action: PayloadAction<number[]>) => {
      // サーバ起点の snapshot を信頼し、そのまま置換（重複のみ除去）。
      state.onlineUserIds = Array.from(
        new Set(action.payload.filter((id) => typeof id === "number")),
      );
    },
    userOnline: (state, action: PayloadAction<number>) => {
      const id = action.payload;
      if (typeof id !== "number") return;
      if (!state.onlineUserIds.includes(id)) {
        state.onlineUserIds.push(id);
      }
    },
    userOffline: (state, action: PayloadAction<number>) => {
      const id = action.payload;
      state.onlineUserIds = state.onlineUserIds.filter((existing) => existing !== id);
    },
    setPresenceConnected: (state, action: PayloadAction<boolean>) => {
      state.isConnected = action.payload;
    },
    resetPresence: () => initialState,
  },
});

export const {
  setPresenceSnapshot,
  userOnline,
  userOffline,
  setPresenceConnected,
  resetPresence,
} = presenceSlice.actions;

export default presenceSlice.reducer;
